import React from 'react';
import SideMenu from '../SideMenu/SideMenu';
import { Privilege } from '../../api';
import usePitches from './usePitches';
import Progress from '../Util/Progress';
import { useSnackbar } from 'notistack';
import usePrivileges, { hasPrivilege } from '../Util/usePrivileges';
import { useLocation } from 'react-router';

interface Props {}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const pitchSort = (a: { name: string }, b: { name: string }) => {
  return a.name.localeCompare(b.name);
};

const PitchSidemenu: React.FunctionComponent<Props> = (props) => {
  const query = useQuery();
  const { pitches, loading, error } = usePitches(!!query.get('allPitches'));
  const { enqueueSnackbar } = useSnackbar();
  const privileges = usePrivileges();

  if (error) {
    enqueueSnackbar('Failed to load pitches', { variant: 'error', autoHideDuration: 3000 });
    return <Progress />;
  }
  if (loading || !pitches) {
    return <Progress />;
  }

  const menuItems = pitches
    .slice()
    .sort(pitchSort)
    .map((pitch) => {
      return {
        title: pitch.name,
        path: '/pitch/' + pitch.id,
        key: String(pitch.id),
      };
    });
  if (hasPrivilege(privileges, [Privilege.Admin, Privilege.WritePitches])) {
    menuItems.push({ title: 'Add new pitch', path: '/pitch/new', key: 'new' });
  } else if (pitches.length === 0) {
    menuItems.push({ title: 'No pitch defined', path: '/pitch', key: 'new' });
  }

  return <SideMenu menuItems={menuItems} />;
};

export default PitchSidemenu;
